import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AuthService } from "../../services/auth.service";
import { LoginService } from "../../services/login.service";
import { ILogin, IUser } from "../../interfaces/ilogin";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";
import { environment } from "../../../environments/environment";

/**
 * @whatIsIt Component for Login
 *
 */
@Component({
    selector: "logon",
    templateUrl: "./login.component.html",
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
    businessFunction: IBusinessFunction | null = null;
    businessFunctionDisplayName = "";
    loginFormGroup!: FormGroup;
    defaultRoute = "";
    loggingIn = false;
    private destroy$ = new Subject<void>();

    constructor(private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private loginService: LoginService) {
        authService.user = null as any;
    }

    /**
     * On initailse of login component.
     * Here it initialises the contents and load the data to display.
     */
    ngOnInit(): void {
        this.authService.user = null as any;
        this.activatedRoute.params
            .pipe(takeUntil(this.destroy$))
            .subscribe((p: Params) => {
                this.defaultRoute = p['defaultroute'];
                this.businessFunction = AuthService.getBusinessFunctionByDefaultRoute(this.defaultRoute);
                if (this.businessFunction != null) {
                    this.authService.businessFunction = null;
                    this.loginFormGroup = new FormGroup({
                        username: new FormControl("", [Validators.required]),
                        password: new FormControl("", [Validators.required]),
                        businessFunctionId: new FormControl(this.businessFunction.id)
                    });
                    this.authService.manualLogin = false;
                    window.location.href = environment.loginRedirectUrl;
                }
            });
    }

    /**
     * Gets called when forgot password link is clicked
     */
    forgotPasswordClicked(): void {
        this.router.navigate([`${this.defaultRoute}/passwordresetrequest`]);
    }

    /**
     * Gets called when the user clicks sign in
     * @param form the form being submitting
     * @param valid whether or not the form is valid
     */
    signInClicked(form: ILogin, valid: boolean): void {
        if (valid) {
            this.loggingIn = true;
            this.loginService.login(form)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    (user: IUser) => {
                        // the user only belongs to one business function so set it
                        // and redirect to the home page
                        const foundFunction = user.businessFunctions.find(e => e.defaultRoute === `/${this.defaultRoute}`);
                        if (foundFunction) {
                            this.authService.businessFunction = foundFunction;
                        }
                        this.loggingIn = false;
                        this.router.navigate([`${this.defaultRoute}`]);
                    },
                    () => {
                        this.loggingIn = false;
                    }
                );
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}